import { User } from 'firebase/auth';
import { IObservableValue, observable } from 'mobx';
import { IAuthService } from '.';
import { AuthUser } from '../../models/User';
import { logger } from 'services/Logger';

export const dummyUser: AuthUser = {
  uid: 'dummyuid',
  displayName: 'Dummy User',
  email: 'dummy@user.com',
  emailVerified: true,
  isAnonymous: false,
  phoneNumber: null,
  photoURL: 'https://spinnax.com/wp-content/uploads/2022/01/logo-240x143.png',
  refreshToken: 'TheRefreshToken1337',
  providerId: 'DummyProvider',
  tenantId: null,
};

class DummyAuth implements IAuthService {
  user: IObservableValue<AuthUser | null> = observable.box(null);
  userToken: IObservableValue<string | undefined> = observable.box(undefined);

  get isNewUser() {
    return false;
  }

  getCurrentUser(): Promise<AuthUser | null> {
    return Promise.resolve(this.user.get());
  }
  async isAuthenticated(): Promise<boolean> {
    const user = await this.getCurrentUser();
    return user !== null;
  }
  async signInWithGoogle(): Promise<User> {
    this.user.set(dummyUser);
    this.userToken.set('NewUserToken');
    return dummyUser as unknown as User;
  }
  signInWithApple(): Promise<User> {
    return this.signInWithGoogle();
  }
  signInWithMail(_email: string, _password: string): Promise<User> {
    return this.signInWithGoogle();
  }
  signUpWithMail(_email: string, _password: string): Promise<User> {
    return this.signInWithGoogle();
  }
  signInAnonymously(): Promise<User> {
    return this.signInWithGoogle();
  }
  signOut(): Promise<void> {
    this.user.set(null);
    logger.info('Dummy User signed out');
    return Promise.resolve();
  }
  sendPasswordResetEmail(_email: string): Promise<void> {
    return this.sendPasswordResetEmail(_email);
  }
  sendEmailVerification(): Promise<void> {
    return this.sendEmailVerification();
  }
  destroy(): void {}
}

export default DummyAuth;
